import { FC } from 'react';
import { InfoCell } from '@edikk-edikk/country-layout-black';
import { useParameterLabel, ParameterType } from '@edikk-edikk/country-frontend';

type PropsType = {
  type: ParameterType;
  value: string;
};

const Parameter: FC<PropsType> = ({
  type,
  value,
}) => {
  const label = useParameterLabel(type);

  return <InfoCell label={label} value={value} />;
};

export { Parameter };
